import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import * as parseDomain from "parse-domain";

import { InputGroup, InputGroupAddon, Input } from 'reactstrap';

const SUBDOMAIN_REGEX = /^[a-z]?[a-z-_]*?[a-z]*$/i;

class SubdomainInput extends PureComponent {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    domains: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    placeholder: '',
    domains: ['example.com'],
  };

  state = {
    subdomain: "",
    domain: this.props.domains[0]
  }

  componentDidMount = () => {
    const { value } = this.props;

    if(value) {
      const data = parseDomain(value);
      const { subdomain, domain, tld } = data;
      this.setState({ subdomain: subdomain, domain: `${domain}.${tld}` });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const { value } = nextProps;

    if(value) {
      let data = parseDomain(value);
      const { subdomain, domain, tld } = data;
      this.setState({ subdomain: subdomain, domain: `${domain}.${tld}` });
    }

  }

  createInputValue = (subdomain, domain) => {
    return `${subdomain}.${domain}`;
  }

  handleSubdomainChange = ({ target }) => {
    const { onChange } = this.props;
    const { value } = target;

    if (SUBDOMAIN_REGEX.test(value)) {
      const domain = this.createInputValue(value.toLowerCase(), this.state.domain);
      onChange(domain);
    }

  }

  handleDomainChange = ({ value }) => {
    const { onChange } = this.props;
    const domain = this.createInputValue(this.state.subdomain, value);
    onChange(domain);
  }

  render() {
    const {
      placeholder, domains, disabled
    } = this.props;

    return (
      <InputGroup>
        <Input
          type="text"
          required
          disabled={disabled}
          placeholder={placeholder}
          value={this.state.subdomain}
          onChange={this.handleSubdomainChange}
          className="domain-subdomain"
          data-lpignore={true} // prevent lastpass from inserting icon
        />
        <InputGroupAddon addonType="append">
          <Select
            isDisabled={disabled}
            value={{ value: this.state.domain, label: `.${this.state.domain}` }}
            onChange={this.handleDomainChange}
            options={domains.map(domain => ({ value: domain, label: `.${domain}` }))}
            clearable={false}
            className="domain-top-level"
            classNamePrefix="react-select"
          />
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

const renderSubdomainInput = (props) => {
  const {
    input, meta, domains, placeholder, disabled
  } = props;

  return (
    <div className="form__form-group-input-wrap">
      <SubdomainInput
        {...input}
        disabled={disabled}
        domains={domains}
        placeholder={placeholder}
      />
      {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
    </div>
  );
};

renderSubdomainInput.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    initial: PropTypes.string,
  }),
  domains: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
};

renderSubdomainInput.defaultProps = {
  meta: null,
  value: null,
  domains: [],
  placeholder: '',
};

export default renderSubdomainInput;
